<script>
    import {Pie, mixins} from 'vue-chartjs'
    const { reactiveProp } = mixins
    import Chart from 'chart.js'

    Chart.pluginService.register({
        beforeDraw: function(chart) {
            if (chart.data.centerText) {
                // Get ctx from string
                var ctx = chart.chart.ctx;

                // Get options from the center object in options
                var centerConfig = chart.data.centerText;
                var centerConfig2 = chart.data.centerText2
                var shiftBaseTextUpPx
                if (centerConfig2 && centerConfig2.shiftBaseTextUpPx)
                    shiftBaseTextUpPx =  -centerConfig2.shiftBaseTextUpPx
                else
                    shiftBaseTextUpPx =  0

                var fontStyle = centerConfig.fontStyle || ' ';
                var font = centerConfig.font || 'Arial';
                var txt = chart.data.datasets[0].data[0] + '%';
                if (txt.length < 3)
                    txt = ' ' + txt
                var color = centerConfig.color || '#000';
                var maxFontSize = centerConfig.maxFontSize || 75;
                var sidePadding = centerConfig.sidePadding || 20;
                var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
                // Start with a base font of 30px
                ctx.font = fontStyle + " 30px " + font;

                // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                var stringWidth = ctx.measureText(txt).width;
                var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

                // Find out how much the font can grow in width.
                var widthRatio = elementWidth / stringWidth;
                var newFontSize = Math.floor(30 * widthRatio);
                var elementHeight = (chart.innerRadius * 2);

                // Pick a new font size so it will not be larger than the height of label.
                var fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
                var minFontSize = centerConfig.minFontSize;
                var lineHeight = centerConfig.lineHeight || 25;
                var wrapText = false;

                if (minFontSize === undefined) {
                    minFontSize = 20;
                }

                if (minFontSize && fontSizeToUse < minFontSize) {
                    fontSizeToUse = minFontSize;
                    wrapText = true;
                }

                // Set font settings to draw it correctly.
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
                var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2) + shiftBaseTextUpPx/31*fontSizeToUse;
                ctx.font = fontStyle + ' ' + fontSizeToUse + "px " + font;
                ctx.fillStyle = color;


                if (!wrapText) {
                    ctx.fillText(txt, centerX, centerY);
                }
                else {
                    var words = txt.split(' ');
                    var line = '';
                    var lines = [];

                    // Break words up into multiple lines if necessary
                    for (var n = 0; n < words.length; n++) {
                        var testLine = line + words[n] + ' ';
                        var metrics = ctx.measureText(testLine);
                        var testWidth = metrics.width;
                        if (testWidth > elementWidth && n > 0) {
                            lines.push(line);
                            line = words[n] + ' ';
                        } else {
                            line = testLine;
                        }
                    }

                    // Move the center up depending on line height and number of lines
                    centerY -= (lines.length / 2) * lineHeight;

                    for (var m = 0; m < lines.length; m++) {
                        ctx.fillText(lines[m], centerX, centerY);
                        centerY += lineHeight;
                    }
                    //Draw text in center
                    ctx.fillText(line, centerX, centerY);
                }

                if (centerConfig2) {
                    var fontSize2 = centerConfig2.fontSize/31*fontSizeToUse
                    var fontStyle2 = centerConfig2.fontStyle || ' ';
                    var font2 = centerConfig2.font || 'Arial'
                    var txt2 = centerConfig2.text;
                    var color2 = centerConfig2.color || '#000'

                    ctx.font = fontStyle2 + ' ' + fontSize2 + "px " + font2;
                    ctx.fillStyle = color2
                    var centerY2 = centerY + centerConfig2.shiftDownPx/31*fontSizeToUse
                    ctx.fillText(txt2, centerX, centerY2)
                }
            }
        }
    });

    export default {
        extends: Pie,
        mixins: [reactiveProp],
        props: ['options'],
        mounted() {
            this.renderChart(this.chartData, this.options)
        }
    }

</script>